import Handlebars from "handlebars";
import {t} from "@lingui/core/macro";

import {doNotTranslate} from "@repo/i18n";

export default () => Handlebars.compile(`<div class="modal-header">
    <span class="close" data-dismiss="modal">&#215;</span>
    <h2>${t`Edit basic info`}</h2>
</div>
<div class="modal-body">
    <div class="notification error" style="display: none;">
        ${t`If you change your username, you cannot get your old one back for 120 days.`}
    </div>
    <div class="username-picker row-fluid">
        <div class="form-horizontal">
            <div class="control-group nickname-row">
                <label class="control-label" for="nickname">
                    ${t`Nickname`}
                </label>
                <div class="controls">
                    <input type="text" value="{{nickname}}" class="nickname" id="nickname"><span class="sidenote"></span>
                    <p class="input-description">
                        ${t`This is how your name will appear around Khan Academy, and how your friends and coaches will recognize you.`}
                    </p>
                </div>
            </div>
            <div class="control-group username-row">
                <label class="control-label" for="username">
                    ${t`Username`}
                </label>
                <div class="controls">
                    <input type="text" value="{{username}}" class="username" id="username"><span class="sidenote"></span>
                    <p class="input-description">
                        ${t`Your username will appear in your Khan Academy address.`}
                        ${doNotTranslate`http://www.khanacademy.org/profile/`}<span class="example-username">{{username}}</span>
                    </p>
                </div>
            </div>
            <div id="profile-info-edit-fields"></div>
            <div id="edit-profile-privacy-indicator"></div>
        </div>
    </div>
</div>
<div class="modal-footer"></div>`) as any;
